import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from '@/shared/components/layout/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';
import { HomePage, OffersMapPage } from '@/features/home';
import { SearchPage } from '@/features/search';
import { PublishPage, EditOfferPage } from '@/features/publish';
import { FavoritesPage } from '@/features/favorites';
import { FavoritesCountProvider } from '@/features/favorites/context/FavoritesCountContext';
import { MessagesPage } from '@/features/messages';
import { ConversationDetailPage } from '@/features/messages/pages/ConversationDetailPage';
import { MyPublicationsPage } from '@/features/my-publications';
import { TokenHandler, AuthErrorPage } from '@/features/auth';
import OfferDetailPage from '@/features/offer-detail/pages/OfferDetailPage';
import ShareOfferHandoffPage from '@/features/offer-detail/pages/ShareOfferHandoffPage';
import { PurchaseHistoryPage } from '@/features/purchases/pages/PurchaseHistoryPage';
import { AlertsPage, CreateAlertPage, EditAlertPage } from '@/features/alerts';
import { NotificationRelayPage } from '@/features/notifications/pages/NotificationRelayPage';

// Feature imports (placeholders - will be implemented per feature)
// import { NotificationsPage } from '@/features/notifications';

export default function AppRouter() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<div>Login Page</div>} />

      {/* Error route - authentication failed */}
      <Route path="/error" element={<AuthErrorPage />} />

      {/* Token handler route - for deep-linking from parent mobile apps */}
      {/* Usage: https://app.rockease.com/auth/token?token=xxx&redirect=/search */}
      <Route path="/auth/token" element={<TokenHandler />} />

      {/* Notification relay route - single entry point for all push notification deep links */}
      {/* Usage (via TokenHandler redirect): /notifications/relay?type=OFFER_MATCH&targetId=offer-123 */}
      <Route path="/notifications/relay" element={<NotificationRelayPage />} />

      {/* Public share handoff route - tokenless share URLs land here first */}
      <Route path="/share/offer" element={<ShareOfferHandoffPage />} />

      {/* Protected routes — single layout with conditional GlobalHeader */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <FavoritesCountProvider>
              <AppLayout />
            </FavoritesCountProvider>
          </ProtectedRoute>
        }
      >
        {/* Main tabs — GlobalHeader shown automatically */}
        <Route index element={<HomePage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="offers-map" element={<OffersMapPage />} />
        <Route path="publish" element={<PublishPage />} />
        <Route path="favorites" element={<FavoritesPage />} />

        {/* Sub-pages — GlobalHeader hidden, each manages its own AppBar */}
        <Route path="offers/:id" element={<OfferDetailPage />} />
        <Route path="offers/:id/edit" element={<EditOfferPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="messages/:id" element={<ConversationDetailPage />} />
        <Route path="my-publications" element={<MyPublicationsPage />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="alerts/create" element={<CreateAlertPage />} />
        <Route path="alerts/:id/edit" element={<EditAlertPage />} />
        <Route path="purchases" element={<PurchaseHistoryPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
